import { Component, Input } from '@angular/core';
import { EverythingSearchResult } from '../../model/everything-search-result';
import { SearchResultSnippetComponent } from '../search-result-snippet/search-result-snippet.component';
import { SearchResultComponent } from '../search-result/search-result.component';

@Component({
  selector: 'app-search-result-generic',
  templateUrl: './search-result-generic.component.html',
  styleUrls: [ './search-result-generic.component.scss' ],
  imports: [ SearchResultComponent, SearchResultSnippetComponent ]
})
export class SearchResultGenericComponent {
  @Input() result: EverythingSearchResult;
  @Input() crumbs: string[] = [];
}
